module.exports = __webpack_public_path__ + "img/calculadora.69acc2f0.svg";